import React from "react";
import { Box, Grid } from "@mui/material";
import ProgressBar from "../../Common/ProgressBar/ProgressBar";

function JobPlanActivitySummary({ activities, contractedHours }) {
    const contractedMinutes = contractedHours * 60;
    let categoryCollection = {};
    let categories = [];

    function duration_minutes(a, b) {
        const start = new Date(a);
        const end = new Date(b);
        let diff = (end.getTime() - start.getTime()) / 1000;
        diff /= 1 * 60;

        return Math.abs(diff);
    }

    function progress(duration, max) {
        let total = (duration / max) * 100;
        return Math.round(total);
    }

    activities.forEach((activity) => {
        let duration = duration_minutes(activity["dateEnd"], activity["dateStart"]);

        if (categoryCollection[activity["category"]["name"]]) {
            categoryCollection[activity["category"]["name"]].total += duration / 60;
            categoryCollection[activity["category"]["name"]].percentage += progress(
                duration,
                contractedMinutes
            );
        } else {
            categoryCollection[activity["category"]["name"]] = {
                id: Object.keys(categoryCollection).length,
                title: activity["category"]["name"],
                type: activity["category"]["type"],
                label: "hrs",
                total: duration / 60,
                percentage: progress(duration, contractedMinutes),
            };
        }
    });

    for (const prop in categoryCollection) {
        categories.push(categoryCollection[prop]);
    }

    return (
        <Box className="card-content">
            <Grid container spacing={2}>
                {categories &&
                    categories.length > 0 &&
                    categories.map((category) => (
                        <ProgressBar data={category} key={category.id} />
                    ))}
            </Grid>
        </Box>
    );
}

export default JobPlanActivitySummary;
